<!-- Feather icons section start -->
<section id="feather-icons">
  <div class="row">
    <div class="col-12">
      <div class="content-header">Feather Icons</div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
        </div>
        <div class="card-content">
          <div class="card-body">
            <div class="feather-icons overflow-hidden">
              <div class="row">
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-alert-octagon"></i>
                  </div>
                  <label class="fonticon-classname">ft-alert-octagon</label>
                  <label class="fonticon-unit">e81b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-alert-circle"></i>
                  </div>
                  <label class="fonticon-classname">ft-alert-circle</label>
                  <label class="fonticon-unit">e81c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-activity"></i>
                  </div>
                  <label class="fonticon-classname">ft-activity</label>
                  <label class="fonticon-unit">e81d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-alert-triangle"></i>
                  </div>
                  <label class="fonticon-classname">ft-alert-triangle</label>
                  <label class="fonticon-unit">e81e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-align-center"></i>
                  </div>
                  <label class="fonticon-classname">ft-align-center</label>
                  <label class="fonticon-unit">e81f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-airplay"></i>
                  </div>
                  <label class="fonticon-classname">ft-airplay</label>
                  <label class="fonticon-unit">e820</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-align-justify"></i>
                  </div>
                  <label class="fonticon-classname">ft-align-justify</label>
                  <label class="fonticon-unit">e821</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-align-left"></i>
                  </div>
                  <label class="fonticon-classname">ft-align-left</label>
                  <label class="fonticon-unit">e822</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-align-right"></i>
                  </div>
                  <label class="fonticon-classname">ft-align-right</label>
                  <label class="fonticon-unit">e823</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-arrow-down-left"></i>
                  </div>
                  <label class="fonticon-classname">ft-arrow-down-left</label>
                  <label class="fonticon-unit">e824</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-arrow-down-right"></i>
                  </div>
                  <label class="fonticon-classname">ft-arrow-down-right</label>
                  <label class="fonticon-unit">e825</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-anchor"></i>
                  </div>
                  <label class="fonticon-classname">ft-anchor</label>
                  <label class="fonticon-unit">e826</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-aperture"></i>
                  </div>
                  <label class="fonticon-classname">ft-aperture</label>
                  <label class="fonticon-unit">e827</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-arrow-left"></i>
                  </div>
                  <label class="fonticon-classname">ft-arrow-left</label>
                  <label class="fonticon-unit">e828</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-arrow-right"></i>
                  </div>
                  <label class="fonticon-classname">ft-arrow-right</label>
                  <label class="fonticon-unit">e829</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-arrow-down"></i>
                  </div>
                  <label class="fonticon-classname">ft-arrow-down</label>
                  <label class="fonticon-unit">e82a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-arrow-up-left"></i>
                  </div>
                  <label class="fonticon-classname">ft-arrow-up-left</label>
                  <label class="fonticon-unit">e82b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-arrow-up-right"></i>
                  </div>
                  <label class="fonticon-classname">ft-arrow-up-right</label>
                  <label class="fonticon-unit">e82c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-arrow-up"></i>
                  </div>
                  <label class="fonticon-classname">ft-arrow-up</label>
                  <label class="fonticon-unit">e82d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-award"></i>
                  </div>
                  <label class="fonticon-classname">ft-award</label>
                  <label class="fonticon-unit">e82e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-bar-chart"></i>
                  </div>
                  <label class="fonticon-classname">ft-bar-chart</label>
                  <label class="fonticon-unit">e82f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-at-sign"></i>
                  </div>
                  <label class="fonticon-classname">ft-at-sign</label>
                  <label class="fonticon-unit">e830</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-bar-chart-2"></i>
                  </div>
                  <label class="fonticon-classname">ft-bar-chart-2</label>
                  <label class="fonticon-unit">e831</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-battery-charging"></i>
                  </div>
                  <label class="fonticon-classname">ft-battery-charging</label>
                  <label class="fonticon-unit">e832</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-bell-off"></i>
                  </div>
                  <label class="fonticon-classname">ft-bell-off</label>
                  <label class="fonticon-unit">e833</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-battery"></i>
                  </div>
                  <label class="fonticon-classname">ft-battery</label>
                  <label class="fonticon-unit">e834</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-bluetooth"></i>
                  </div>
                  <label class="fonticon-classname">ft-bluetooth</label>
                  <label class="fonticon-unit">e835</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-bell"></i>
                  </div>
                  <label class="fonticon-classname">ft-bell</label>
                  <label class="fonticon-unit">e836</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-book"></i>
                  </div>
                  <label class="fonticon-classname">ft-book</label>
                  <label class="fonticon-unit">e837</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-briefcase"></i>
                  </div>
                  <label class="fonticon-classname">ft-briefcase</label>
                  <label class="fonticon-unit">e838</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-camera-off"></i>
                  </div>
                  <label class="fonticon-classname">ft-camera-off</label>
                  <label class="fonticon-unit">e839</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-calendar"></i>
                  </div>
                  <label class="fonticon-classname">ft-calendar</label>
                  <label class="fonticon-unit">e83a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-bookmark"></i>
                  </div>
                  <label class="fonticon-classname">ft-bookmark</label>
                  <label class="fonticon-unit">e83b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-box"></i>
                  </div>
                  <label class="fonticon-classname">ft-box</label>
                  <label class="fonticon-unit">e83c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-camera"></i>
                  </div>
                  <label class="fonticon-classname">ft-camera</label>
                  <label class="fonticon-unit">e83d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-check-circle"></i>
                  </div>
                  <label class="fonticon-classname">ft-check-circle</label>
                  <label class="fonticon-unit">e83e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-check"></i>
                  </div>
                  <label class="fonticon-classname">ft-check</label>
                  <label class="fonticon-unit">e83f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-check-square"></i>
                  </div>
                  <label class="fonticon-classname">ft-check-square</label>
                  <label class="fonticon-unit">e840</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-cast"></i>
                  </div>
                  <label class="fonticon-classname">ft-cast</label>
                  <label class="fonticon-unit">e841</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-chevron-down"></i>
                  </div>
                  <label class="fonticon-classname">ft-chevron-down</label>
                  <label class="fonticon-unit">e842</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-chevron-left"></i>
                  </div>
                  <label class="fonticon-classname">ft-chevron-left</label>
                  <label class="fonticon-unit">e843</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-chevron-right"></i>
                  </div>
                  <label class="fonticon-classname">ft-chevron-right</label>
                  <label class="fonticon-unit">e844</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-chevron-up"></i>
                  </div>
                  <label class="fonticon-classname">ft-chevron-up</label>
                  <label class="fonticon-unit">e845</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-chevrons-down"></i>
                  </div>
                  <label class="fonticon-classname">ft-chevrons-down</label>
                  <label class="fonticon-unit">e846</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-chevrons-right"></i>
                  </div>
                  <label class="fonticon-classname">ft-chevrons-right</label>
                  <label class="fonticon-unit">e847</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-chevrons-up"></i>
                  </div>
                  <label class="fonticon-classname">ft-chevrons-up</label>
                  <label class="fonticon-unit">e848</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-chevrons-left"></i>
                  </div>
                  <label class="fonticon-classname">ft-chevrons-left</label>
                  <label class="fonticon-unit">e849</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-circle"></i>
                  </div>
                  <label class="fonticon-classname">ft-circle</label>
                  <label class="fonticon-unit">e84a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-clipboard"></i>
                  </div>
                  <label class="fonticon-classname">ft-clipboard</label>
                  <label class="fonticon-unit">e84b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-chrome"></i>
                  </div>
                  <label class="fonticon-classname">ft-chrome</label>
                  <label class="fonticon-unit">e84c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-clock"></i>
                  </div>
                  <label class="fonticon-classname">ft-clock</label>
                  <label class="fonticon-unit">e84d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-cloud-lightning"></i>
                  </div>
                  <label class="fonticon-classname">ft-cloud-lightning</label>
                  <label class="fonticon-unit">e84e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-cloud-drizzle"></i>
                  </div>
                  <label class="fonticon-classname">ft-cloud-drizzle</label>
                  <label class="fonticon-unit">e84f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-cloud-rain"></i>
                  </div>
                  <label class="fonticon-classname">ft-cloud-rain</label>
                  <label class="fonticon-unit">e850</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-cloud-off"></i>
                  </div>
                  <label class="fonticon-classname">ft-cloud-off</label>
                  <label class="fonticon-unit">e851</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-codepen"></i>
                  </div>
                  <label class="fonticon-classname">ft-codepen</label>
                  <label class="fonticon-unit">e852</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-cloud-snow"></i>
                  </div>
                  <label class="fonticon-classname">ft-cloud-snow</label>
                  <label class="fonticon-unit">e853</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-compass"></i>
                  </div>
                  <label class="fonticon-classname">ft-compass</label>
                  <label class="fonticon-unit">e854</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-copy"></i>
                  </div>
                  <label class="fonticon-classname">ft-copy</label>
                  <label class="fonticon-unit">e855</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-corner-down-right"></i>
                  </div>
                  <label class="fonticon-classname">ft-corner-down-right</label>
                  <label class="fonticon-unit">e856</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-corner-down-left"></i>
                  </div>
                  <label class="fonticon-classname">ft-corner-down-left</label>
                  <label class="fonticon-unit">e857</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-corner-left-down"></i>
                  </div>
                  <label class="fonticon-classname">ft-corner-left-down</label>
                  <label class="fonticon-unit">e858</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-corner-left-up"></i>
                  </div>
                  <label class="fonticon-classname">ft-corner-left-up</label>
                  <label class="fonticon-unit">e859</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-corner-up-left"></i>
                  </div>
                  <label class="fonticon-classname">ft-corner-up-left</label>
                  <label class="fonticon-unit">e85a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-corner-up-right"></i>
                  </div>
                  <label class="fonticon-classname">ft-corner-up-right</label>
                  <label class="fonticon-unit">e85b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-corner-right-down"></i>
                  </div>
                  <label class="fonticon-classname">ft-corner-right-down</label>
                  <label class="fonticon-unit">e85c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-corner-right-up"></i>
                  </div>
                  <label class="fonticon-classname">ft-corner-right-up</label>
                  <label class="fonticon-unit">e85d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-cpu"></i>
                  </div>
                  <label class="fonticon-classname">ft-cpu</label>
                  <label class="fonticon-unit">e85e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-credit-card"></i>
                  </div>
                  <label class="fonticon-classname">ft-credit-card</label>
                  <label class="fonticon-unit">e85f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-crosshair"></i>
                  </div>
                  <label class="fonticon-classname">ft-crosshair</label>
                  <label class="fonticon-unit">e860</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-disc"></i>
                  </div>
                  <label class="fonticon-classname">ft-disc</label>
                  <label class="fonticon-unit">e861</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-delete"></i>
                  </div>
                  <label class="fonticon-classname">ft-delete</label>
                  <label class="fonticon-unit">e862</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-download-cloud"></i>
                  </div>
                  <label class="fonticon-classname">ft-download-cloud</label>
                  <label class="fonticon-unit">e863</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-download"></i>
                  </div>
                  <label class="fonticon-classname">ft-download</label>
                  <label class="fonticon-unit">e864</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-droplet"></i>
                  </div>
                  <label class="fonticon-classname">ft-droplet</label>
                  <label class="fonticon-unit">e865</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-edit-2"></i>
                  </div>
                  <label class="fonticon-classname">ft-edit-2</label>
                  <label class="fonticon-unit">e866</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-edit"></i>
                  </div>
                  <label class="fonticon-classname">ft-edit</label>
                  <label class="fonticon-unit">e867</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-edit-1"></i>
                  </div>
                  <label class="fonticon-classname">ft-edit-1</label>
                  <label class="fonticon-unit">e868</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-external-link"></i>
                  </div>
                  <label class="fonticon-classname">ft-external-link</label>
                  <label class="fonticon-unit">e869</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-eye"></i>
                  </div>
                  <label class="fonticon-classname">ft-eye</label>
                  <label class="fonticon-unit">e86a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-feather"></i>
                  </div>
                  <label class="fonticon-classname">ft-feather</label>
                  <label class="fonticon-unit">e86b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-facebook"></i>
                  </div>
                  <label class="fonticon-classname">ft-facebook</label>
                  <label class="fonticon-unit">e86c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-file-minus"></i>
                  </div>
                  <label class="fonticon-classname">ft-file-minus</label>
                  <label class="fonticon-unit">e86d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-eye-off"></i>
                  </div>
                  <label class="fonticon-classname">ft-eye-off</label>
                  <label class="fonticon-unit">e86e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-fast-forward"></i>
                  </div>
                  <label class="fonticon-classname">ft-fast-forward</label>
                  <label class="fonticon-unit">e86f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-file-text"></i>
                  </div>
                  <label class="fonticon-classname">ft-file-text</label>
                  <label class="fonticon-unit">e870</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-film"></i>
                  </div>
                  <label class="fonticon-classname">ft-film</label>
                  <label class="fonticon-unit">e871</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-file"></i>
                  </div>
                  <label class="fonticon-classname">ft-file</label>
                  <label class="fonticon-unit">e872</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-file-plus"></i>
                  </div>
                  <label class="fonticon-classname">ft-file-plus</label>
                  <label class="fonticon-unit">e873</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-folder"></i>
                  </div>
                  <label class="fonticon-classname">ft-folder</label>
                  <label class="fonticon-unit">e874</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-filter"></i>
                  </div>
                  <label class="fonticon-classname">ft-filter</label>
                  <label class="fonticon-unit">e875</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-flag"></i>
                  </div>
                  <label class="fonticon-classname">ft-flag</label>
                  <label class="fonticon-unit">e876</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-globe"></i>
                  </div>
                  <label class="fonticon-classname">ft-globe</label>
                  <label class="fonticon-unit">e877</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-grid"></i>
                  </div>
                  <label class="fonticon-classname">ft-grid</label>
                  <label class="fonticon-unit">e878</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-heart"></i>
                  </div>
                  <label class="fonticon-classname">ft-heart</label>
                  <label class="fonticon-unit">e879</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-home"></i>
                  </div>
                  <label class="fonticon-classname">ft-home</label>
                  <label class="fonticon-unit">e87a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-github"></i>
                  </div>
                  <label class="fonticon-classname">ft-github</label>
                  <label class="fonticon-unit">e87b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-image"></i>
                  </div>
                  <label class="fonticon-classname">ft-image</label>
                  <label class="fonticon-unit">e87c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-inbox"></i>
                  </div>
                  <label class="fonticon-classname">ft-inbox</label>
                  <label class="fonticon-unit">e87d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-layers"></i>
                  </div>
                  <label class="fonticon-classname">ft-layers</label>
                  <label class="fonticon-unit">e87e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-info"></i>
                  </div>
                  <label class="fonticon-classname">ft-info</label>
                  <label class="fonticon-unit">e87f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-instagram"></i>
                  </div>
                  <label class="fonticon-classname">ft-instagram</label>
                  <label class="fonticon-unit">e880</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-layout"></i>
                  </div>
                  <label class="fonticon-classname">ft-layout</label>
                  <label class="fonticon-unit">e881</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-link-2"></i>
                  </div>
                  <label class="fonticon-classname">ft-link-2</label>
                  <label class="fonticon-unit">e882</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-life-buoy"></i>
                  </div>
                  <label class="fonticon-classname">ft-life-buoy</label>
                  <label class="fonticon-unit">e883</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-link"></i>
                  </div>
                  <label class="fonticon-classname">ft-link</label>
                  <label class="fonticon-unit">e884</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-log-in"></i>
                  </div>
                  <label class="fonticon-classname">ft-log-in</label>
                  <label class="fonticon-unit">e885</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-list"></i>
                  </div>
                  <label class="fonticon-classname">ft-list</label>
                  <label class="fonticon-unit">e886</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-lock"></i>
                  </div>
                  <label class="fonticon-classname">ft-lock</label>
                  <label class="fonticon-unit">e887</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-log-out"></i>
                  </div>
                  <label class="fonticon-classname">ft-log-out</label>
                  <label class="fonticon-unit">e888</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-loader"></i>
                  </div>
                  <label class="fonticon-classname">ft-loader</label>
                  <label class="fonticon-unit">e889</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-mail"></i>
                  </div>
                  <label class="fonticon-classname">ft-mail</label>
                  <label class="fonticon-unit">e88a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-maximize-2"></i>
                  </div>
                  <label class="fonticon-classname">ft-maximize-2</label>
                  <label class="fonticon-unit">e88b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-map"></i>
                  </div>
                  <label class="fonticon-classname">ft-map</label>
                  <label class="fonticon-unit">e88c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-map-pin"></i>
                  </div>
                  <label class="fonticon-classname">ft-map-pin</label>
                  <label class="fonticon-unit">e88e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-menu"></i>
                  </div>
                  <label class="fonticon-classname">ft-menu</label>
                  <label class="fonticon-unit">e88f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-message-circle"></i>
                  </div>
                  <label class="fonticon-classname">ft-message-circle</label>
                  <label class="fonticon-unit">e890</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-message-square"></i>
                  </div>
                  <label class="fonticon-classname">ft-message-square</label>
                  <label class="fonticon-unit">e891</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-minimize-2"></i>
                  </div>
                  <label class="fonticon-classname">ft-minimize-2</label>
                  <label class="fonticon-unit">e892</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-mic-off"></i>
                  </div>
                  <label class="fonticon-classname">ft-mic-off</label>
                  <label class="fonticon-unit">e893</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-minus-circle"></i>
                  </div>
                  <label class="fonticon-classname">ft-minus-circle</label>
                  <label class="fonticon-unit">e894</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-mic"></i>
                  </div>
                  <label class="fonticon-classname">ft-mic</label>
                  <label class="fonticon-unit">e895</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-minus-square"></i>
                  </div>
                  <label class="fonticon-classname">ft-minus-square</label>
                  <label class="fonticon-unit">e896</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-minus"></i>
                  </div>
                  <label class="fonticon-classname">ft-minus</label>
                  <label class="fonticon-unit">e897</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-moon"></i>
                  </div>
                  <label class="fonticon-classname">ft-moon</label>
                  <label class="fonticon-unit">e898</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-monitor"></i>
                  </div>
                  <label class="fonticon-classname">ft-monitor</label>
                  <label class="fonticon-unit">e899</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-more-vertical"></i>
                  </div>
                  <label class="fonticon-classname">ft-more-vertical</label>
                  <label class="fonticon-unit">e89a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-more-horizontal"></i>
                  </div>
                  <label class="fonticon-classname">ft-more-horizontal</label>
                  <label class="fonticon-unit">e89b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-move"></i>
                  </div>
                  <label class="fonticon-classname">ft-move</label>
                  <label class="fonticon-unit">e89c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-music"></i>
                  </div>
                  <label class="fonticon-classname">ft-music</label>
                  <label class="fonticon-unit">e89d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-navigation-2"></i>
                  </div>
                  <label class="fonticon-classname">ft-navigation-2</label>
                  <label class="fonticon-unit">e89e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-navigation"></i>
                  </div>
                  <label class="fonticon-classname">ft-navigation</label>
                  <label class="fonticon-unit">e89f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-octagon"></i>
                  </div>
                  <label class="fonticon-classname">ft-octagon</label>
                  <label class="fonticon-unit">e8a0</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-package"></i>
                  </div>
                  <label class="fonticon-classname">ft-package</label>
                  <label class="fonticon-unit">e8a1</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-pause-circle"></i>
                  </div>
                  <label class="fonticon-classname">ft-pause-circle</label>
                  <label class="fonticon-unit">e8a2</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-pause"></i>
                  </div>
                  <label class="fonticon-classname">ft-pause</label>
                  <label class="fonticon-unit">e8a3</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-percent"></i>
                  </div>
                  <label class="fonticon-classname">ft-percent</label>
                  <label class="fonticon-unit">e8a4</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-phone-call"></i>
                  </div>
                  <label class="fonticon-classname">ft-phone-call</label>
                  <label class="fonticon-unit">e8a5</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-phone-forwarded"></i>
                  </div>
                  <label class="fonticon-classname">ft-phone-forwarded</label>
                  <label class="fonticon-unit">e8a6</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-phone-missed"></i>
                  </div>
                  <label class="fonticon-classname">ft-phone-missed</label>
                  <label class="fonticon-unit">e8a7</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-phone-off"></i>
                  </div>
                  <label class="fonticon-classname">ft-phone-off</label>
                  <label class="fonticon-unit">e8a8</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-phone-incoming"></i>
                  </div>
                  <label class="fonticon-classname">ft-phone-incoming</label>
                  <label class="fonticon-unit">e8a9</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-phone"></i>
                  </div>
                  <label class="fonticon-classname">ft-phone</label>
                  <label class="fonticon-unit">e8aa</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-phone-outgoing"></i>
                  </div>
                  <label class="fonticon-classname">ft-phone-outgoing</label>
                  <label class="fonticon-unit">e8ab</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-pie-chart"></i>
                  </div>
                  <label class="fonticon-classname">ft-pie-chart</label>
                  <label class="fonticon-unit">e8ac</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-play-circle"></i>
                  </div>
                  <label class="fonticon-classname">ft-play-circle</label>
                  <label class="fonticon-unit">e8ad</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-play"></i>
                  </div>
                  <label class="fonticon-classname">ft-play</label>
                  <label class="fonticon-unit">e8ae</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-plus-square"></i>
                  </div>
                  <label class="fonticon-classname">ft-plus-square</label>
                  <label class="fonticon-unit">e8af</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-plus-circle"></i>
                  </div>
                  <label class="fonticon-classname">ft-plus-circle</label>
                  <label class="fonticon-unit">e8b0</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-plus"></i>
                  </div>
                  <label class="fonticon-classname">ft-plus</label>
                  <label class="fonticon-unit">e8b1</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-pocket"></i>
                  </div>
                  <label class="fonticon-classname">ft-pocket</label>
                  <label class="fonticon-unit">e8b2</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-printer"></i>
                  </div>
                  <label class="fonticon-classname">ft-printer</label>
                  <label class="fonticon-unit">e8b3</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-power"></i>
                  </div>
                  <label class="fonticon-classname">ft-power</label>
                  <label class="fonticon-unit">e8b4</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-radio"></i>
                  </div>
                  <label class="fonticon-classname">ft-radio</label>
                  <label class="fonticon-unit">e8b5</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-repeat"></i>
                  </div>
                  <label class="fonticon-classname">ft-repeat</label>
                  <label class="fonticon-unit">e8b6</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-refresh-ccw"></i>
                  </div>
                  <label class="fonticon-classname">ft-refresh-ccw</label>
                  <label class="fonticon-unit">e8b7</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-rewind"></i>
                  </div>
                  <label class="fonticon-classname">ft-rewind</label>
                  <label class="fonticon-unit">e8b8</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-rotate-ccw"></i>
                  </div>
                  <label class="fonticon-classname">ft-rotate-ccw</label>
                  <label class="fonticon-unit">e8b9</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-refresh-cw"></i>
                  </div>
                  <label class="fonticon-classname">ft-refresh-cw</label>
                  <label class="fonticon-unit">e8ba</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-rotate-cw"></i>
                  </div>
                  <label class="fonticon-classname">ft-rotate-cw</label>
                  <label class="fonticon-unit">e8bb</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-save"></i>
                  </div>
                  <label class="fonticon-classname">ft-save</label>
                  <label class="fonticon-unit">e8bc</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-search"></i>
                  </div>
                  <label class="fonticon-classname">ft-search</label>
                  <label class="fonticon-unit">e8bd</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-server"></i>
                  </div>
                  <label class="fonticon-classname">ft-server</label>
                  <label class="fonticon-unit">e8be</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-scissors"></i>
                  </div>
                  <label class="fonticon-classname">ft-scissors</label>
                  <label class="fonticon-unit">e8bf</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-share-2"></i>
                  </div>
                  <label class="fonticon-classname">ft-share-2</label>
                  <label class="fonticon-unit">e8c0</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-share"></i>
                  </div>
                  <label class="fonticon-classname">ft-share</label>
                  <label class="fonticon-unit">e8c1</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-shield"></i>
                  </div>
                  <label class="fonticon-classname">ft-shield</label>
                  <label class="fonticon-unit">e8c2</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-settings"></i>
                  </div>
                  <label class="fonticon-classname">ft-settings</label>
                  <label class="fonticon-unit">e8c3</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-skip-back"></i>
                  </div>
                  <label class="fonticon-classname">ft-skip-back</label>
                  <label class="fonticon-unit">e8c4</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-shuffle"></i>
                  </div>
                  <label class="fonticon-classname">ft-shuffle</label>
                  <label class="fonticon-unit">e8c5</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-sidebar"></i>
                  </div>
                  <label class="fonticon-classname">ft-sidebar</label>
                  <label class="fonticon-unit">e8c6</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-skip-forward"></i>
                  </div>
                  <label class="fonticon-classname">ft-skip-forward</label>
                  <label class="fonticon-unit">e8c7</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-slack"></i>
                  </div>
                  <label class="fonticon-classname">ft-slack</label>
                  <label class="fonticon-unit">e8c8</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-slash"></i>
                  </div>
                  <label class="fonticon-classname">ft-slash</label>
                  <label class="fonticon-unit">e8c9</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-smartphone"></i>
                  </div>
                  <label class="fonticon-classname">ft-smartphone</label>
                  <label class="fonticon-unit">e8ca</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-square"></i>
                  </div>
                  <label class="fonticon-classname">ft-square</label>
                  <label class="fonticon-unit">e8cb</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-speaker"></i>
                  </div>
                  <label class="fonticon-classname">ft-speaker</label>
                  <label class="fonticon-unit">e8cc</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-star"></i>
                  </div>
                  <label class="fonticon-classname">ft-star</label>
                  <label class="fonticon-unit">e8cd</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-stop-circle"></i>
                  </div>
                  <label class="fonticon-classname">ft-stop-circle</label>
                  <label class="fonticon-unit">e8ce</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-sun"></i>
                  </div>
                  <label class="fonticon-classname">ft-sun</label>
                  <label class="fonticon-unit">e8cf</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-sunrise"></i>
                  </div>
                  <label class="fonticon-classname">ft-sunrise</label>
                  <label class="fonticon-unit">e8d0</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-tablet"></i>
                  </div>
                  <label class="fonticon-classname">ft-tablet</label>
                  <label class="fonticon-unit">e8d1</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-tag"></i>
                  </div>
                  <label class="fonticon-classname">ft-tag</label>
                  <label class="fonticon-unit">e8d2</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-sunset"></i>
                  </div>
                  <label class="fonticon-classname">ft-sunset</label>
                  <label class="fonticon-unit">e8d3</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-target"></i>
                  </div>
                  <label class="fonticon-classname">ft-target</label>
                  <label class="fonticon-unit">e8d4</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-thermometer"></i>
                  </div>
                  <label class="fonticon-classname">ft-thermometer</label>
                  <label class="fonticon-unit">e8d5</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-thumbs-up"></i>
                  </div>
                  <label class="fonticon-classname">ft-thumbs-up</label>
                  <label class="fonticon-unit">e8d6</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-thumbs-down"></i>
                  </div>
                  <label class="fonticon-classname">ft-thumbs-down</label>
                  <label class="fonticon-unit">e8d7</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-toggle-left"></i>
                  </div>
                  <label class="fonticon-classname">ft-toggle-left</label>
                  <label class="fonticon-unit">e8d8</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-toggle-right"></i>
                  </div>
                  <label class="fonticon-classname">ft-toggle-right</label>
                  <label class="fonticon-unit">e8d9</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-trash-2"></i>
                  </div>
                  <label class="fonticon-classname">ft-trash-2</label>
                  <label class="fonticon-unit">e8da</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-trash"></i>
                  </div>
                  <label class="fonticon-classname">ft-trash</label>
                  <label class="fonticon-unit">e8db</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-trending-up"></i>
                  </div>
                  <label class="fonticon-classname">ft-trending-up</label>
                  <label class="fonticon-unit">e8dc</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-trending-down"></i>
                  </div>
                  <label class="fonticon-classname">ft-trending-down</label>
                  <label class="fonticon-unit">e8dd</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-triangle"></i>
                  </div>
                  <label class="fonticon-classname">ft-triangle</label>
                  <label class="fonticon-unit">e8de</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-type"></i>
                  </div>
                  <label class="fonticon-classname">ft-type</label>
                  <label class="fonticon-unit">e8df</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-twitter"></i>
                  </div>
                  <label class="fonticon-classname">ft-twitter</label>
                  <label class="fonticon-unit">e8e0</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-upload"></i>
                  </div>
                  <label class="fonticon-classname">ft-upload</label>
                  <label class="fonticon-unit">e8e1</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-umbrella"></i>
                  </div>
                  <label class="fonticon-classname">ft-umbrella</label>
                  <label class="fonticon-unit">e8e2</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-upload-cloud"></i>
                  </div>
                  <label class="fonticon-classname">ft-upload-cloud</label>
                  <label class="fonticon-unit">e8e3</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-unlock"></i>
                  </div>
                  <label class="fonticon-classname">ft-unlock</label>
                  <label class="fonticon-unit">e8e4</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-user-check"></i>
                  </div>
                  <label class="fonticon-classname">ft-user-check</label>
                  <label class="fonticon-unit">e8e5</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-user-minus"></i>
                  </div>
                  <label class="fonticon-classname">ft-user-minus</label>
                  <label class="fonticon-unit">e8e6</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-user-plus"></i>
                  </div>
                  <label class="fonticon-classname">ft-user-plus</label>
                  <label class="fonticon-unit">e8e7</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-user-x"></i>
                  </div>
                  <label class="fonticon-classname">ft-user-x</label>
                  <label class="fonticon-unit">e8e8</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-user"></i>
                  </div>
                  <label class="fonticon-classname">ft-user</label>
                  <label class="fonticon-unit">e8e9</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-users"></i>
                  </div>
                  <label class="fonticon-classname">ft-users</label>
                  <label class="fonticon-unit">e8ea</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-video-off"></i>
                  </div>
                  <label class="fonticon-classname">ft-video-off</label>
                  <label class="fonticon-unit">e8eb</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-video"></i>
                  </div>
                  <label class="fonticon-classname">ft-video</label>
                  <label class="fonticon-unit">e8ec</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-voicemail"></i>
                  </div>
                  <label class="fonticon-classname">ft-voicemail</label>
                  <label class="fonticon-unit">e8ed</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-volume-x"></i>
                  </div>
                  <label class="fonticon-classname">ft-volume-x</label>
                  <label class="fonticon-unit">e8ee</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-volume-2"></i>
                  </div>
                  <label class="fonticon-classname">ft-volume-2</label>
                  <label class="fonticon-unit">e8ef</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-volume-1"></i>
                  </div>
                  <label class="fonticon-classname">ft-volume-1</label>
                  <label class="fonticon-unit">e8f0</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-volume"></i>
                  </div>
                  <label class="fonticon-classname">ft-volume</label>
                  <label class="fonticon-unit">e8f1</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-watch"></i>
                  </div>
                  <label class="fonticon-classname">ft-watch</label>
                  <label class="fonticon-unit">e8f2</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-wifi"></i>
                  </div>
                  <label class="fonticon-classname">ft-wifi</label>
                  <label class="fonticon-unit">e8f3</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-x-square"></i>
                  </div>
                  <label class="fonticon-classname">ft-x-square</label>
                  <label class="fonticon-unit">e8f4</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-wind"></i>
                  </div>
                  <label class="fonticon-classname">ft-wind</label>
                  <label class="fonticon-unit">e8f5</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-x"></i>
                  </div>
                  <label class="fonticon-classname">ft-x</label>
                  <label class="fonticon-unit">e8f6</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-x-circle"></i>
                  </div>
                  <label class="fonticon-classname">ft-x-circle</label>
                  <label class="fonticon-unit">e8f7</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-zap"></i>
                  </div>
                  <label class="fonticon-classname">ft-zap</label>
                  <label class="fonticon-unit">e8f8</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-zoom-in"></i>
                  </div>
                  <label class="fonticon-classname">ft-zoom-in</label>
                  <label class="fonticon-unit">e8f9</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-zoom-out"></i>
                  </div>
                  <label class="fonticon-classname">ft-zoom-out</label>
                  <label class="fonticon-unit">e8fa</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-command"></i>
                  </div>
                  <label class="fonticon-classname">ft-command</label>
                  <label class="fonticon-unit">e8fb</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-cloud"></i>
                  </div>
                  <label class="fonticon-classname">ft-cloud</label>
                  <label class="fonticon-unit">e8fc</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-hash"></i>
                  </div>
                  <label class="fonticon-classname">ft-hash</label>
                  <label class="fonticon-unit">e8fd</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-headphones"></i>
                  </div>
                  <label class="fonticon-classname">ft-headphones</label>
                  <label class="fonticon-unit">e8fe</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-underline"></i>
                  </div>
                  <label class="fonticon-classname">ft-underline</label>
                  <label class="fonticon-unit">e8ff</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-italic"></i>
                  </div>
                  <label class="fonticon-classname">ft-italic</label>
                  <label class="fonticon-unit">e900</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-bold"></i>
                  </div>
                  <label class="fonticon-classname">ft-bold</label>
                  <label class="fonticon-unit">e901</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-crop"></i>
                  </div>
                  <label class="fonticon-classname">ft-crop</label>
                  <label class="fonticon-unit">e902</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-help-circle"></i>
                  </div>
                  <label class="fonticon-classname">ft-help-circle</label>
                  <label class="fonticon-unit">e903</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-paperclip"></i>
                  </div>
                  <label class="fonticon-classname">ft-paperclip</label>
                  <label class="fonticon-unit">e904</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-shopping-cart"></i>
                  </div>
                  <label class="fonticon-classname">ft-shopping-cart</label>
                  <label class="fonticon-unit">e905</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-tv"></i>
                  </div>
                  <label class="fonticon-classname">ft-tv</label>
                  <label class="fonticon-unit">e906</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-wifi-off"></i>
                  </div>
                  <label class="fonticon-classname">ft-wifi-off</label>
                  <label class="fonticon-unit">e907</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-minimize"></i>
                  </div>
                  <label class="fonticon-classname">ft-minimize</label>
                  <label class="fonticon-unit">e88d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-maximize"></i>
                  </div>
                  <label class="fonticon-classname">ft-maximize</label>
                  <label class="fonticon-unit">e908</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-gitlab"></i>
                  </div>
                  <label class="fonticon-classname">ft-gitlab</label>
                  <label class="fonticon-unit">e909</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-sliders"></i>
                  </div>
                  <label class="fonticon-classname">ft-sliders</label>
                  <label class="fonticon-unit">e90a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-star-on"></i>
                  </div>
                  <label class="fonticon-classname">ft-star-on</label>
                  <label class="fonticon-unit">e90b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-heart-on"></i>
                  </div>
                  <label class="fonticon-classname">ft-heart-on</label>
                  <label class="fonticon-unit">e90c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-archive"></i>
                  </div>
                  <label class="fonticon-classname">ft-archive</label>
                  <label class="fonticon-unit">e90d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-arrow-down-circle"></i>
                  </div>
                  <label class="fonticon-classname">ft-arrow-down-circle</label>
                  <label class="fonticon-unit">e90e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-arrow-up-circle"></i>
                  </div>
                  <label class="fonticon-classname">ft-arrow-up-circle</label>
                  <label class="fonticon-unit">e90f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-arrow-left-circle"></i>
                  </div>
                  <label class="fonticon-classname">ft-arrow-left-circle</label>
                  <label class="fonticon-unit">e910</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-arrow-right-circle"></i>
                  </div>
                  <label class="fonticon-classname">ft-arrow-right-circle</label>
                  <label class="fonticon-unit">e911</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-bar-chart-line-"></i>
                  </div>
                  <label class="fonticon-classname">ft-bar-chart-line-</label>
                  <label class="fonticon-unit">e912</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-bar-chart-line"></i>
                  </div>
                  <label class="fonticon-classname">ft-bar-chart-line</label>
                  <label class="fonticon-unit">e913</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-book-open"></i>
                  </div>
                  <label class="fonticon-classname">ft-book-open</label>
                  <label class="fonticon-unit">e914</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-code"></i>
                  </div>
                  <label class="fonticon-classname">ft-code</label>
                  <label class="fonticon-unit">e915</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-database"></i>
                  </div>
                  <label class="fonticon-classname">ft-database</label>
                  <label class="fonticon-unit">e916</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-dollar-sign"></i>
                  </div>
                  <label class="fonticon-classname">ft-dollar-sign</label>
                  <label class="fonticon-unit">e917</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-folder-plus"></i>
                  </div>
                  <label class="fonticon-classname">ft-folder-plus</label>
                  <label class="fonticon-unit">e918</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-gift"></i>
                  </div>
                  <label class="fonticon-classname">ft-gift</label>
                  <label class="fonticon-unit">e919</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-folder-minus"></i>
                  </div>
                  <label class="fonticon-classname">ft-folder-minus</label>
                  <label class="fonticon-unit">e91a</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-git-commit"></i>
                  </div>
                  <label class="fonticon-classname">ft-git-commit</label>
                  <label class="fonticon-unit">e91b</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-git-branch"></i>
                  </div>
                  <label class="fonticon-classname">ft-git-branch</label>
                  <label class="fonticon-unit">e91c</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-git-pull-request"></i>
                  </div>
                  <label class="fonticon-classname">ft-git-pull-request</label>
                  <label class="fonticon-unit">e91d</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-git-merge"></i>
                  </div>
                  <label class="fonticon-classname">ft-git-merge</label>
                  <label class="fonticon-unit">e91e</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-linkedin"></i>
                  </div>
                  <label class="fonticon-classname">ft-linkedin</label>
                  <label class="fonticon-unit">e91f</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-hard-drive"></i>
                  </div>
                  <label class="fonticon-classname">ft-hard-drive</label>
                  <label class="fonticon-unit">e920</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-more-vertical-"></i>
                  </div>
                  <label class="fonticon-classname">ft-more-vertical-</label>
                  <label class="fonticon-unit">e921</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-more-horizontal-"></i>
                  </div>
                  <label class="fonticon-classname">ft-more-horizontal-</label>
                  <label class="fonticon-unit">e922</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-rss"></i>
                  </div>
                  <label class="fonticon-classname">ft-rss</label>
                  <label class="fonticon-unit">e923</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-send"></i>
                  </div>
                  <label class="fonticon-classname">ft-send</label>
                  <label class="fonticon-unit">e924</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-shield-off"></i>
                  </div>
                  <label class="fonticon-classname">ft-shield-off</label>
                  <label class="fonticon-unit">e925</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-shopping-bag"></i>
                  </div>
                  <label class="fonticon-classname">ft-shopping-bag</label>
                  <label class="fonticon-unit">e926</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-terminal"></i>
                  </div>
                  <label class="fonticon-classname">ft-terminal</label>
                  <label class="fonticon-unit">e927</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-truck"></i>
                  </div>
                  <label class="fonticon-classname">ft-truck</label>
                  <label class="fonticon-unit">e928</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-zap-off"></i>
                  </div>
                  <label class="fonticon-classname">ft-zap-off</label>
                  <label class="fonticon-unit">e929</label>
                </div>
                <div class="col-md-4 col-sm-6 col-12 fonticon-container">
                  <div class="fonticon-wrap">
                    <i class="ft-youtube"></i>
                  </div>
                  <label class="fonticon-classname">ft-youtube</label>
                  <label class="fonticon-unit">e92a</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- // Feather icons section end -->
